import { FC, Fragment } from 'react';
import { Link as RRLink, LinkProps } from 'react-router-dom';
import { cn, FaIcon } from '@fe-learner-common';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons/faArrowLeft';

type TBreadcrumbItem = { label: string; href: string };
type BreadcrumbProps = {
  rootTitle: string;
  items: Array<TBreadcrumbItem>;
  className?: string;
  isLoading?: boolean;
};

const Link: FC<{ isLoading?: boolean } & LinkProps> = ({
  isLoading,
  ...rest
}) => {
  if (isLoading) {
    return (
      <div className="my-2 h-5 w-[100px] animate-pulse rounded-md bg-neutral-100  text-neutral-100" />
    );
  }

  return <RRLink {...rest} />;
};
export const Breadcrumb: FC<BreadcrumbProps> = ({
  items,
  rootTitle,
  className,
  isLoading,
}) => {
  if (!items.length) {
    return null;
  }

  return (
    <nav
      className={cn(
        '-ms-1 flex flex-wrap items-center gap-1 overflow-hidden',
        className,
      )}
    >
      <Link
        isLoading={isLoading}
        to={'/'}
        className="l-btn l-btn-sm l-btn-tertiary"
      >
        <FaIcon className="md:hidden" icon={faArrowLeft} rtlSupport />
        <span className="hidden md:inline">{rootTitle}</span>
      </Link>
      <FaIcon
        className="hidden px-1 text-neutral-500 md:inline"
        icon={faChevronRight}
        rtlSupport
        height={12}
      />
      {items.map((item, index) => {
        return (
          <Fragment key={self.crypto.randomUUID()}>
            <Link
              isLoading={isLoading}
              className={cn(
                'l-btn l-btn-tertiary l-btn-sm whitespace-pre-wrap',
              )}
              to={item.href}
            >
              {item.label}
            </Link>
            {index < items.length - 1 && (
              <FaIcon
                className="px-1 text-neutral-500"
                icon={faChevronRight}
                rtlSupport
                height={12}
              />
            )}
          </Fragment>
        );
      })}
    </nav>
  );
};
